<template>
  <b-container>
    <b-row>
      <h2>NF-e das solicitações de coleta</h2>
    </b-row>

    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="filter"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :filter-debounce="500"
      >
        <template #thead-top>
          <b-tr style="">
            <b-th></b-th>
            <!--<b-th>
                  Cachorrinho123
                </b-th> -->
            <b-th>
              <b-form-input
                v-model="filter.id"
                placeholder="Filtrar pelo Id:"
              />
            </b-th>

            <b-th>
              <b-form-input
                v-model="filter.displayName"
                type="text"
                placeholder="Filtrar pelo Nome:"
              />
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(chaveAcessoNfe)="data">
          <a href="#" @click.prevent="downloadXml(data.item.chaveAcessoNfe)">
            <u>
              {{ data.item.chaveAcessoNfe }}
              <i class="tim-icons icon-attach-87"></i>
            </u>
          </a>
        </template>
      </b-table>

      <b-col>
        <table-pagination
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :rowCount.sync="tableRowCount"
          :perPage.sync="tablePerPage"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
  
  <script>
import axios from "axios";

export default {
  components: {
    TablePagination: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      isBusy: false,
      fields: [
        // {
        //   key: "actions",
        //   label: "",
        //   thStyle: "width: 240px",
        // },
        // {
        //   key: "id",
        //   sortable: true,
        //   label: "Id",
        //   thStyle: "width: 150px",
        // },
        {
          key: `chaveAcessoNfe`,
          label: `Chave Acesso NF-e`,
        },
        // {
        //   key: `CreatedAt`,
        //   sortable: true,
        //   label: `CreatedAt`,
        // },
        {
          key: `dataColeta`,
          label: `Data Coleta`,
        },
        {
          key: `dataPedido`,
          label: `Data Pedido`,
        },
        {
          key: `numeroNfe`,
          label: `Número NF-e`,
        },
        {
          key: `numeroPedido`,
          label: `Número Pedido`,
        },
      ],
      tableRowCount: 0,
      tablePerPage: 20,
      tablePageOptions: [5, 10, 20, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      filter: { displayName: "", id: "" },
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    downloadXml(chaveAcessoNfe) {
      axios
        .create({
          baseURL: this.$store.getters.urlWorkflow, // `http://20.206.131.138:80`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .request({
          url: `/freteRapido/solicitacaoColeta/nfe/downloadXml?chaveAcessoNFe=${chaveAcessoNfe}`,
          method: "GET",
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `${chaveAcessoNfe}.xml`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
    },
    async myProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
      };
      axios
        .create({
          baseURL: this.$store.getters.urlWorkflow, // `http://20.206.131.138:80`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .post("/freteRapido/solicitacaoColeta/nfe/paginate", apiFilter)
        .then((response) => {
          const items = response.data.items;
          console.log(response.data);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });

      return null;
    },
  },
};
</script>